<template>
  <table class="document-node__alt-table" :aria-labelledby="`${value.uuid}-chart-title`">
    <thead>
      <tr>
        <th scope="col">Question</th>
        <th v-for="(col, i) in timeColumns" :key="i" scope="col">
          {{ col }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, rIndex) in value.content.data" :key="`row-${rIndex}`">
        <td>{{ row.label }}</td>

        <td v-for="(ts, cIndex) in row.time_series_scores" :key="`cell-${rIndex}-${cIndex}`">
          {{ extractValue(ts, row.label) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'HorizontalLineChartTable',
  props: {
    value: PigeonDocNodeModel,
  },

  computed: {
    timeColumns() {
      // Build column headers from the first row’s time series
      const first = this.value.content.data[0]?.time_series_scores || [];
      return first.map((ts) => {
        const start = ts.start.slice(0, 10);
        const end = ts.end.slice(0, 10);
        return `${start} → ${end}`;
      });
    },
  },

  methods: {
    extractValue(ts, rowLabel) {
      const mode = this.value.meta.performanceMode;

      // 1. Primary modes
      if (mode === 'Means/averages' && ts.mean != null) {
        return this.round2(ts.mean);
      }

      if (mode === 'Volumes' && ts.valid_size != null) {
        return this.round2(ts.valid_size);
      }

      // 2. Fallback: compound score
      if (ts.compound_score != null) {
        return this.round2(ts.compound_score);
      }

      // 3. Fallback: filtered coverage (text analysis)
      if (ts.filtered_coverage && ts.filtered_coverage.denominator > 0) {
        const { total, denominator } = ts.filtered_coverage;
        const ratio = total / denominator;
        return this.round2(ratio);
      }

      // 4. Fallback: drivers
      if (Array.isArray(ts.drivers)) {
        const match = ts.drivers.find((d) => d.driver === rowLabel);
        if (match && match.coefficient != null) {
          return this.round2(match.coefficient);
        }
      }

      // 5. Final fallback
      return '';
    },
    round2(v) {
      return Math.round(v * 100) / 100;
    },
  },
};
</script>
